import { createSlice, combineReducers } from '@reduxjs/toolkit'

import { reducer as active, fetchMemberships } from './active_users/slice'
import { reducer as migrating, fetchMigrations } from './migrating_users/slice'
import { reducer as pending, fetchInvitations } from './pending_users/slice'

const setStatistics = (state, { payload }) => {
  state.available_seats = payload.meta.statistics.available_seats
  state.occupancy_ratio = payload.meta.statistics.occupancy_ratio
  state.users = payload.meta.statistics.users
  state.invitations = payload.meta.statistics.invitations
  state.migrations = payload.meta.statistics.migrations
}

const statistics = createSlice({
  name: 'usersPage/statistics',
  initialState: { available_seats: 0, occupancy_ratio: '', users: null, invitations: null, migrations: null },
  extraReducers: (builder) => {
    builder.addCase(fetchMemberships.fulfilled, setStatistics)
    builder.addCase(fetchInvitations.fulfilled, setStatistics)
    builder.addCase(fetchMigrations.fulfilled, setStatistics)
  }
})

export const reducer = combineReducers({ statistics: statistics.reducer, active, pending, migrating })
